import { StarIcon } from "@heroicons/react/20/solid";
import { PhotoModalContent, ReviewPhotoCard, reviewPhotoModalStyles } from "common/pages/Review/ReviewDetail";
import ReviewList from "common/pages/Review/ReviewList";
import BasicArticle from "components/Article/Basic";
import Badges from "components/Badges";
import Card from "components/Card";
import { useModal } from "components/Modal/Simple";
import SpinnerMedium from "components/Spinner/Medium";
import { formatDate, formatDateTime, truncate } from "components/Table/Simple/presets";
import _ from "lodash";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const ReviewCard = ({ review }) => {
    const navigate = useNavigate();
    const { Modal: PhotoModal, openModal, closeModal } = useModal(reviewPhotoModalStyles);

    return (
        <div >
            <div className="cursor-pointer" onClick={() => {
                console.log("[ReviewCard] onClick");
                navigate(`/contents/review/${review.id}`);
            }}>
                {/* <img
                        src={UrlUtils.convertCdnUrl(review.mainImage)}
                        alt="profileImage"
                        className="h-24 w-24 p-2 object-center group-hover:opacity-75"
                    /> */}
                <div className="p-2 flex flex-col space-y-2">
                    <div className="">
                        <h1 className="text-md font-bold">
                            {/* {`${review.writer.name}님의 리뷰`} */}
                            {`${review.title}`}
                        </h1>
                        <div className="flex">
                            <StarIcon className="w-4 h-4 text-yellow-400" />
                            <span className="text-gray-500 text-xs">
                                {numeral(review.rating).format("0.0")}
                            </span>
                            <h1 className="text-xs text-gray-500 ps-1">
                                {'·'}
                            </h1>
                            <h1 className="text-xs text-gray-500 ps-1">
                                {formatDateTime(review.created_at)}
                            </h1>
                        </div>
                    </div>
                    {!_.isEmpty(review?.treatments) && (
                        <div className="flex items-center space-x-2">
                            <div>
                                <Badges
                                    items={review.treatments.map((item) => item.name)}
                                    isRemovable={false}
                                />
                            </div>
                        </div>
                    )}
                    {(!_.isEmpty(review?.beforePhotos) || !_.isEmpty(review?.afterPhotos)) && (
                        <div className="mt-3 overflow-auto" onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            openModal();
                        }}>
                            <div className="flex space-x-3 pb-3 min-w-max">
                                {review?.beforePhotos?.length > 0 && review.beforePhotos.map((file, idx) => (
                                    <ReviewPhotoCard
                                        key={idx}
                                        url={file?.url}
                                        idx={idx}
                                        type="전"
                                    />
                                ))}
                                {review?.afterPhotos?.length > 0 && review.afterPhotos.map((file, idx) => (
                                    <ReviewPhotoCard
                                        key={idx}
                                        url={file?.url}
                                        idx={idx}
                                        type="후"
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                    <BasicArticle>
                        <div className="text-sm leading-normal">
                            {truncate(review.content, 100)}
                        </div>
                    </BasicArticle>
                    {/* <div className="flex items-center">
                            <span className="text-pink-700 text-xs">
                                {`¥${numeral(price).format("0,0")}`}
                            </span>
                            <span className="text-gray-600 text-[10px] ps-1">
                                {` | 通常価格：¥${numeral(originPrice).format("0,0")}`}
                            </span>
                        </div> */}
                    {/* <div>
                            <Badges
                                items={doctor.specialties.map((sp) => sp.name)}
                                isRemovable={false}
                            />
                        </div> */}
                </div>
            </div>
            <PhotoModal>
                <PhotoModalContent
                    beforePhotos={review.beforePhotos}
                    afterPhotos={review.afterPhotos}
                    onCloseClicked={(e) => {
                        closeModal();
                    }}
                />
            </PhotoModal>
        </div>
    )
}

const ClinicReviewList = ({ clinicInfo }) => {
    return (
        <ReviewList filterParams={{ clinicId: clinicInfo.id }} />
    )
}

export default ClinicReviewList;
